// extracted by mini-css-extract-plugin
export default {"logo":"Dashboard_logo__-hT40","container":"Dashboard_container__WG1C1","heading":"Dashboard_heading__TkYd2","cards":"Dashboard_cards__FpNez"};